import { getOnlineStoreTags } from "@/api/delivery"
import { handleGetCartDetailV2 } from "@/utils/cartResponse"
import { noAddressCheck, base64Decode, getLoginStatus } from "@/utils/utils"
export function getCartListByCart(storeGroup) {
  const cartList = []
  let num = 0
  storeGroup.forEach(v => {
    num += Number(v.checkedCountWithoutGift)
    v.wareGroup.forEach(_v => {
      if (_v.wares) {
        _v.wares.forEach(__v => {
          cartList.push({
            sku: __v.sku,
            count: __v.count,
            stock: __v.stock
          })
        })
      }
    })
  })
  return {
    cartList,
    num
  }
}

export default {
  async created() {
    if (!process.client) {
      return
    }
    const { isOnline } = getLoginStatus()
    if (!isOnline) {
      await this.initOnlineStoreTags()
    }
    if (isOnline) {
      if (noAddressCheck()) {
        await this.initOnlineStoreTags()
      } else {
        await this.getCartDetail()
      }
    }
  },
  methods: {
    async initOnlineStoreTags() {
      try {
        const { custId } = localStorage.getItem("accountInfo") ? base64Decode(localStorage.getItem("accountInfo")) : {}
        const { commonReqParams } = this.$commonParams
        const { data: res } = await getOnlineStoreTags({
          param: JSON.stringify({
            latitude: commonReqParams.deliveryLat,
            longitude: commonReqParams.deliveryLng,
            custId: custId || ""
          })
        })
        if (res.tip) {
          this.$bus.$emit("setOnlineStoreTags", { tip: res.tip })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getCartDetail() {
      const [error, data] = await handleGetCartDetailV2()
    }
  }
}
